import React, { useState } from "react";
import { Box, Paper } from "@material-ui/core";
import dashboardStyle from "../Layout/DashboardStyle";
import StudentResister from "../Layout/StudentResister";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import { Grid } from "@mui/material";

export default function Students() {
  const classes = dashboardStyle();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Grid container className={classes.root}>
      <Header mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Paper>
          <Box p={3}>
            <StudentResister />
          </Box>
        </Paper>
      </main>
    </Grid>
  );
}
